export function isValidString(value, required = true, maxLength = 255) {
  if (!value && !required) return true;
  if (!value) return false;
  if (typeof value !== "string") return false;
  return value.length <= maxLength;
}

export function isValidEmail(value, required = true, maxLength = 50, genericAllowed = true) {
  if (!value && !required) return true;
  if (!value) return false;
  if (value.length > maxLength) return false;
  const isValid = /^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/.test(value);
  if (!isValid) return false;
  if (genericAllowed) return true;

  const genericDomains = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "hotmail.com",
    "icloud.com",
    "aol.com",
    "protonmail.com",
  ];

  const domain = value.split("@")[1];
  return !genericDomains.includes(domain);
}

export function isValidPhone(value, required) {
  // Requires an integer between 10 & 13 characters inclusive
  if (!value && !required) return true;
  if (required && !value) return false;
  if (!Number.isInteger(value)) return false;
  if (!value && required) return false;
  let valueLength = value.toString().length;
  return valueLength >= 10 && valueLength <= 13;
}

export function isValidPassword(value) {
  if (!value) return false;

  let valueLength = ("" + value).length;
  if (valueLength < 8 || valueLength > 255) return false;

  const hasLowerCase = /[a-z]/.test(value);
  const hasUpperCase = /[A-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[!"#$%&'()*+,-./:;?@[\]^_`{|}~ ]/.test(value);

  return hasLowerCase && hasUpperCase && hasNumber && hasSpecialChar;
}

export function isValidURL(value, required) {
  if (!required && !value) return true;
  if (!value) return false;
  return /^(https?:\/\/)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)?$/gi.test(
    value
  );
}

export function isValidUsername(value, required = true) {
  if (!value && !required) return true;
  if (!value) return false;

  // Must be 5-30 characters
  if (value.length < 5) return false;
  if (value.length > 30) return false;

  if (!/^[a-z]/.test(value)) return false; // Must start with a letter
  if (/\.\./.test(value)) return false; // No two consecutive periods
  if (!/[a-z0-9]$/.test(value)) return false; // Ends with an alphanumeric character
  if (value !== value.toLowerCase()) return false; // Must be all lowercase
  return /^[a-z0-9.]*$/.test(value); // Can include letters, numbers, and periods
}

export function isValidNumber(value, minInclusive, maxInclusive) {
  return !isNaN(value) && value >= minInclusive && value <= maxInclusive;
}
